import Icon from "../../Icon";
import Text from "../../Text";
import "./index.css";

export interface ListItemProps {
  icon: string;
  iconColor?: string;
  iconCustomStyle?: React.CSSProperties;
  text: string;
  textCustomStyle?: React.CSSProperties;
  listItemCustomStyle?: React.CSSProperties;
}

const ListItem = ({
  icon,
  iconColor,
  iconCustomStyle,
  text,
  textCustomStyle,
  listItemCustomStyle,
}: ListItemProps) => (
  <div className="base-list-item" style={listItemCustomStyle}>
    <Icon style={iconCustomStyle} type={icon} color={iconColor} />
    <Text
      text={text}
      style={{
        color: "white",
        fontFamily: "Myriad Pro",
        fontSize: "28px",
        fontWeight: 400,
        marginTop: "24px",
        lineHeight: "120%",
        letterSpacing: "-0.12px",
        ...textCustomStyle,
      }}
    />
  </div>
);

export default ListItem;
